import { Card, CardContent, styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const CardStyled = styled(Card)(() => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  border: `0.06rem solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '2rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));
